import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	viewAllResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewAllResults: {
		id: 'command-palette-quick-search.common.view-all-results',
		defaultMessage: 'View all results',
		description: 'Link to respective results page with search prefilled',
	},
});
